/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Box, Grid, IconButton, Tooltip } from '@mui/material';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import validate from 'validate.js';
import moment from 'moment';
import * as selectorsControleFrequencias from '../../../store/controleFrequencia/reducer';
import * as actionsControleFrequencias from '../../../store/controleFrequencia/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as Role from '../../../constants/role';
import {
  DialogDefaultV2,
  ImageViewerV2,
  InputV2,
  InputFormatV2,
  UsuarioSelectV2,
  OptionSelectV2,
  DatePickerV2,
  DropzoneV2,
  TabFormV2,
  WidgetV2,
} from '../../../components/v2';
import InspecoesDia from '../JornadaMedicao/InspecoesDia';
import { convertTimeToMinutes, isNullOrUndefined, isValidTime, formatToTime } from 'utils';

const HORARIOS = [
  { timeField: 'inicioJornada', photoField: 'fotoInicioJornada', label: 'Inicio Jornada' },
  { timeField: 'inicioIntervalo', photoField: 'fotoInicioIntervalo', label: 'Inicio Intervalo' },
  { timeField: 'finalIntervalo', photoField: 'fotoFinalIntervalo', label: 'Final Intervalo' },
  { timeField: 'finalJornada', photoField: 'fotoFinalJornada', label: 'Final Jornada' },
];

const IMAGE_EXT = ['png', 'jpg', 'jpeg', 'webp', 'gif'];

const imageSrcOf = (file) => {
  if (!file) return null;
  const name = String(file.name || file.nome || '');
  const ext = name.includes('.') ? name.split('.').pop().toLowerCase() : '';
  if (ext && !IMAGE_EXT.includes(ext)) return null;
  if (file instanceof Blob) return URL.createObjectURL(file);
  if (typeof file.url === 'string') return file.url;
  return null;
};

const defaultSchema = {
  data: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  tipoServico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  cidade: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  inspetor: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  inicioJornada: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  fotoInicioJornada: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const validateInvalidTimes = (values) => {
  let errors = {};

  if (!isNullOrUndefined(values.inicioJornada) && !isValidTime(values.inicioJornada)) {
    errors = { ...errors, inicioJornada: ['Horário inválido'] };
  }
  if (!isNullOrUndefined(values.inicioIntervalo) && !isValidTime(values.inicioIntervalo)) {
    errors = { ...errors, inicioIntervalo: ['Horário inválido'] };
  }
  if (!isNullOrUndefined(values.finalIntervalo) && !isValidTime(values.finalIntervalo)) {
    errors = { ...errors, finalIntervalo: ['Horário inválido'] };
  }
  if (!isNullOrUndefined(values.finalJornada) && !isValidTime(values.finalJornada)) {
    errors = { ...errors, finalJornada: ['Horário inválido'] };
  }

  return errors;
};

const hasError = (values) => {
  let schema = defaultSchema;

  if (
    (values.inicioIntervalo != null && values.fotoInicioIntervalo == null)
    || (values.inicioIntervalo == null && values.fotoInicioIntervalo != null)
  ) {
    schema = {
      ...schema,
      inicioIntervalo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      fotoInicioIntervalo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
    };
  }

  if (
    (values.finalIntervalo != null && values.fotoFinalIntervalo == null)
    || (values.finalIntervalo == null && values.fotoFinalIntervalo != null)
  ) {
    schema = {
      ...schema,
      finalIntervalo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      fotoFinalIntervalo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
    };
  }

  if (
    (values.finalJornada != null && values.fotoFinalJornada == null)
    || (values.finalJornada == null && values.fotoFinalJornada != null)
  ) {
    schema = {
      ...schema,
      finalJornada: { presence: { allowEmpty: false, message: 'é obrigatório' } },
      fotoFinalJornada: { presence: { allowEmpty: false, message: 'é obrigatório' } },
    };
  }

  return {
    ...validate(values, schema),
    ...validateInvalidTimes(values),
  };
};

const buildDropzoneFiles = (file, onClear) => (
  file != null
    ? [{
      file,
      nome: file.name,
      onDelete: onClear,
    }]
    : []
);

const Formulario = ({
  open,
  id,
  onClose,
  loadControleFrequencia,
  controleFrequencia,
  saveControleFrequencia,
  authData,
}) => {
  const [readOnly, setReadOnly] = useState(false);
  const [errors, setErrors] = useState({});
  const [tab, setTab] = useState(0);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerIndex, setViewerIndex] = useState(0);
  const [fotoSrcs, setFotoSrcs] = useState({});
  const [values, setValues] = useState({
    data: moment().valueOf(),
    tipoControle: 'CONTROLE_JORNADA',
  });

  useEffect(() => {
    if (id) loadControleFrequencia(id);
  }, [id, loadControleFrequencia]);

  useEffect(() => {
    if (id && controleFrequencia && id === controleFrequencia.id) {
      setValues({
        ...controleFrequencia,
        data: moment(parseInt(controleFrequencia.data, 10)).valueOf(),
      });
      setReadOnly(authData.id !== controleFrequencia.criadoPor);
    } else {
      setValues({ data: moment().valueOf(), tipoControle: 'CONTROLE_JORNADA' });
      setReadOnly(false);
    }
  }, [controleFrequencia, id, authData.id]);

  useEffect(() => {
    const urls = {};
    const created = [];
    HORARIOS.forEach(({ photoField }) => {
      const src = imageSrcOf(values[photoField]);
      if (!src) return;
      urls[photoField] = src;
      if (values[photoField] instanceof Blob) created.push(src);
    });
    setFotoSrcs(urls);
    return () => {
      created.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [
    values.fotoInicioJornada,
    values.fotoInicioIntervalo,
    values.fotoFinalIntervalo,
    values.fotoFinalJornada,
  ]);

  const fotosJornada = useMemo(() => (
    HORARIOS.flatMap(({ photoField, label, timeField }) => {
      const src = fotoSrcs[photoField];
      if (!src) return [];
      return [{
        tipo: photoField,
        src,
        nome: [label, values[timeField]].filter(Boolean).join(' · '),
      }];
    })
  ), [fotoSrcs, values]);

  const onSave = () => {
    const erros = hasError(values);
    if (erros != null && Object.keys(erros).length > 0) {
      setErrors(erros);
      return;
    }
    saveControleFrequencia(values, () => onCloseLocal(true));
  };

  const onCloseLocal = (isSave) => {
    setErrors({});
    setValues({ data: moment().valueOf(), tipoControle: 'CONTROLE_JORNADA' });
    setReadOnly(false);
    setTab(0);
    setViewerOpen(false);
    onClose(isSave);
  };

  const openFoto = (photoField) => {
    const index = fotosJornada.findIndex((foto) => foto.tipo === photoField);
    if (index < 0) return;
    setViewerIndex(index);
    setViewerOpen(true);
  };

  const onChange = (e, field) => {
    const value = e.target.value;

    const inicioJornadaMinutes = convertTimeToMinutes(field === 'inicioJornada' ? value : values.inicioJornada);
    const inicioIntervaloMinutes = convertTimeToMinutes(field === 'inicioIntervalo' ? value : values.inicioIntervalo);
    const finalIntervaloMinutes = convertTimeToMinutes(field === 'finalIntervalo' ? value : values.finalIntervalo);
    const finalJornadaMinutes = convertTimeToMinutes(field === 'finalJornada' ? value : values.finalJornada);

    const first = (inicioJornadaMinutes && inicioIntervaloMinutes && inicioIntervaloMinutes > inicioJornadaMinutes)
      ? inicioIntervaloMinutes - inicioJornadaMinutes
      : null;
    const second = (finalJornadaMinutes && finalIntervaloMinutes && finalJornadaMinutes > finalIntervaloMinutes)
      ? finalJornadaMinutes - finalIntervaloMinutes
      : null;
    const jornadaTotal = first !== null || second !== null ? (first || 0) + (second || 0) : null;

    setValues({
      ...values,
      [field]: value,
      jornadaTotal: jornadaTotal ? formatToTime(jornadaTotal) : null,
    });
  };

  const informacoesGerais = (
    <Grid container spacing={1} sx={{ mt: 0 }}>
      <Grid size={{ xs: 12, sm: 3 }}>
        <DatePickerV2
          label="Data"
          onChange={(data) => setValues({ ...values, data })}
          value={values.data}
          isRequired
          error={!!(errors && errors.data)}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <OptionSelectV2
          label="Tipo de Serviços"
          codigo="TIPO_SERVICO"
          isRequired
          error={!!(errors && errors.tipoServico)}
          onSelect={(tipoServico) => setValues({ ...values, tipoServico })}
          value={values.tipoServico}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <InputV2
          error={!!(errors && errors.cidade)}
          isRequired
          label="Cidade"
          name="cidade"
          onChange={(event) => setValues({
            ...values,
            cidade: event.target.value || null,
          })}
          value={values.cidade || ''}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <UsuarioSelectV2
          label="Inspetor"
          onSelect={(inspetor) => setValues({ ...values, inspetor })}
          isRequired
          error={!!(errors && errors.inspetor)}
          grupos={[Role.ADMIN, Role.INSPETOR]}
          value={values.inspetor}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <UsuarioSelectV2
          label="Parceiro"
          onSelect={(inspetorAuxiliar) => setValues({ ...values, inspetorAuxiliar })}
          grupos={[Role.ADMIN, Role.INSPETOR]}
          value={values.inspetorAuxiliar}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <WidgetV2
          title="Horários"
          collapse={false}
          initialExpanded
          insideTab
          sxContent={{ p: 1.5 }}
        >
          <Grid container spacing={1}>
            {HORARIOS.map(({ timeField, photoField, label }) => {
              const fotoSrc = fotoSrcs[photoField];
              return (
                <Grid key={timeField} size={{ xs: 12, sm: 6 }}>
                  <Box sx={{ position: 'relative', pr: '46px' }}>
                    <InputFormatV2
                      label={label}
                      value={values[timeField]}
                      onChange={(e) => onChange(e, timeField)}
                      format="##:##"
                      placeholder="HH:MM"
                      disabled={readOnly}
                      isRequired={timeField === 'inicioJornada'}
                      error={!!(errors && errors[timeField])}
                      helperText={errors && errors[timeField] ? errors[timeField] : null}
                    />
                    {fotoSrc ? (
                      <Tooltip title="Ver foto">
                        <IconButton
                          size="small"
                          aria-label={`Ver foto de ${label}`}
                          onClick={() => openFoto(photoField)}
                          sx={{
                            position: 'absolute',
                            right: 0,
                            bottom: 0,
                            width: 40,
                            height: 40,
                            border: 1,
                            borderColor: 'primary.main',
                            borderRadius: 1,
                            color: 'primary.main',
                          }}
                        >
                          <PhotoCameraOutlinedIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                  </Box>
                  {!readOnly ? (
                    <DropzoneV2
                      buttonText="Foto"
                      filesLimit={1}
                      acceptedFiles={['.png', '.pdf', '.jpeg', '.jpg']}
                      error={!!(errors && errors[photoField])}
                      onSave={(files) => {
                        if (files != null && files.length > 0) {
                          setValues({ ...values, [photoField]: files[0] });
                        }
                      }}
                      showGridFiles
                      files={buildDropzoneFiles(
                        values[photoField],
                        () => setValues({ ...values, [photoField]: null }),
                      )}
                      canDeleteFiles
                    />
                  ) : null}
                </Grid>
              );
            })}
            <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 1.5 }}>
              <Box sx={{ pr: '46px' }}>
                <InputV2 label="Hora Total Trabalhada" disabled value={values.jornadaTotal || ''} />
              </Box>
            </Grid>
          </Grid>
        </WidgetV2>
      </Grid>
    </Grid>
  );

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Jornada"
      confirmMessage="Salvar"
      maxWidth="lg"
      fullWidth
      readOnly={readOnly}
    >
      <TabFormV2
        currentTab={tab}
        onChangeTab={setTab}
        tabPanels={[
          { label: 'Informações gerais', element: informacoesGerais },
          {
            label: 'Inspeções',
            element: (
              <InspecoesDia
                usuarioId={values.inspetor}
                dia={values.data}
                tipoServicoId={values.tipoServico}
                inicioJornada={values.inicioJornada}
              />
            ),
          },
        ]}
      />
      <ImageViewerV2
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
        images={fotosJornada}
        activeIndex={viewerIndex}
      />
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  loadControleFrequencia: PropTypes.func.isRequired,
  controleFrequencia: PropTypes.object,
  saveControleFrequencia: PropTypes.func.isRequired,
  authData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  controleFrequencia: selectorsControleFrequencias.getSelectedControleFrequencia(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...actionsControleFrequencias,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
